import { Component, Input, OnInit } from '@angular/core';
import { Delivery } from 'src/app/domain/models/Delivery';
import { ImportOrder } from 'src/app/domain/models/ImportOrder';
import { Exporter, Profile } from 'src/app/domain/models/Profile';

@Component({
  selector: 'app-import-order-bill-info',
  templateUrl: './import-order-bill-info.component.html',
  styleUrls: ['./import-order-bill-info.component.css']
})
export class ImportOrderBillInfoComponent implements OnInit {

  @Input()
  delivery: Delivery | undefined

  @Input()
  importer: Profile | undefined

  @Input()
  exporters: Exporter[] = []

  addressConsignee: string = ""
  addressNotify: string = ""
  addressImporter: string = ""

  ngOnInit(): void {
    if(this.delivery){
      this.addressConsignee = `${this.delivery.consigneeContactAddress}, ${this.delivery.consigneeContactCity}`;
      this.addressNotify = `${this.delivery.notifierContactAddress}, ${this.delivery.notifierContactCity}`;
    }
    if(this.importer){
      this.addressImporter = `${this.importer.contactAddress}, ${this.importer.contactCity}`;
    }

  }
}
